<!--
/**
 *@author hhy 
 *@date 2023-2-9
  财务管理 对账管理 商户账单明细
*/
-->
<template>
  <custom-list
    warm-tips=""
    :search-data="searchData"
    :search-params="searchParams"
    :show-header="true"
    table-title="商户账单明细"
    :table-columns="tableColumns"
    :table-operate-buttons="tableOperateButtons"
    :request-method="reconciliationApi.merchantDetailList"
    :show-top-buttons="true"
    :page-top-buttons="pageTopButtons"
    :header-buttons="headerButtons"
    @clear-form="clearForm" />
</template>

<script>
  import { commission, reconciliationApi } from '@/service/apis';
  // import ScrollLayout from '@/layouts/ScrollLayout.vue';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import CustomList from '@/components/biz/CustomList.vue';
  import { offlineExport } from '@/utils';

  export default {
    name: 'MerchantStatementsDetail',
    components: { CustomList },
    data() {
      return {
        id: '',
        tradeTime: '',
        reconciliationApi,
        dictionary: {},
        polymerizationInfo: {},
        pageButtons: [
          {
            id: '2',
            text: '导出',
            type: 'plain',
            handleClick: () => {
              this.doExportFile();
            },
          },
        ],
        pageTopButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: (item, ctx) => {
              console.log('-> item', item);
              console.log('-> ctx', ctx);
              this.$router.go(-1);
            },
          },
        ],
        tableData: [],
        tableOperateButtons: [],
        tableColumns: [
          { label: '订单号', prop: 'tradeSeq', minWidth: '200px' },
          { label: '电站名称', prop: 'stationName', minWidth: '160px' },
          { label: '商户名称', prop: 'operatorName', minWidth: '160px' },
          { label: '结算时间', prop: 'tradeTime', minWidth: '200px' },
          { label: '用户账号', prop: 'userAccount', minWidth: '150px' },
          { label: '归属客户', prop: 'userOrg', minWidth: '150px' },
          { label: '充电量', prop: 'totalDegree', minWidth: '150px' },
          { label: '标准价电费', prop: 'totalStandardChargeFee', minWidth: '150px' },
          {
            label: '标准价服务费',
            prop: 'totalStandardServiceFee',
            minWidth: '150px',
          },
          {
            label: '商户电费活动抵扣',
            prop: 'operatorChargeDiscountAmt',
            minWidth: '150px',
          },
          {
            label: '商户服务费活动抵扣',
            prop: 'operatorServiceDiscountAmt',
            minWidth: '150px',
          },
          {
            label: '商户电费卡券抵扣',
            prop: 'operatorCardChargeDiscountAmt',
            minWidth: '150px',
          },
          {
            label: '商户服务费卡券抵扣',
            prop: 'operatorCardServiceDiscountAmt',
            minWidth: '150px',
          },
          {
            label: '抽成费用',
            prop: 'commissionAmt',
            minWidth: '100px',
          },
          {
            label: '商户实收',
            prop: 'actualIncome',
            minWidth: '100px',
          },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          // userAccount: '',
          // userName: '',
          // phoneNumber: '',
          // userId: '',
          // belongTo: '',
        },
        showDrawer: false,
        isEdit: false,
      };
    },
    created() {
      const { id, tradeTime, queryType } = this.$route.query;
      this.id = id;
      this.tradeTime = tradeTime;
      this.queryType = queryType;
      this.searchParams.operatorId = id;
      this.searchParams.tradeTime = tradeTime;
      this.searchParams.queryType = queryType;
    },
    activated() {},
    computed: {
      headerButtons() {
        return [
          {
            label: '导出',
            handle: (data, ctx) => {
              console.log('-> data', data);
              console.log('-> ctx', ctx);
              offlineExport(
                {
                  downloadType: 'OPERATOR_BILL_DETAIL',
                  jsonNode: {
                    // downloadKey: 'message',
                    ...ctx.searchParams,
                  },
                },
                ctx.pageInfo.total
              );
            },
          },
        ];
      },
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'orderNo',
            label: '充电单号',
            placeholder: '请输入充电单号',
          },
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcInput',
            key: 'userId',
            label: '用户账号',
            placeholder: '请输入用户账号',
          },
          {
            comName: 'YkcInput',
            key: 'userOrg',
            label: '归属客户',
            placeholder: '请输入归属客户',
          },
        ];
      },
    },
    methods: {
      clearForm(data) {
        this.searchParams = {
          ...data,
          operatorId: this.id,
          tradeTime: this.tradeTime,
          queryType: this.queryType,
        };
      },
      handleChange(event, data) {
        console.log('event:', event);
        console.log('data:', data);
      },
      changeStateSearch() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      /** 根据条件查询数据 */
      searchTableList() {
        Promise.all([
          commission.list({
            ...this.pageInfo,
            body: this.searchParams,
          }),
          commission.polymerization(this.searchParams),
        ]).then(([res1, res2]) => {
          this.tableData = res1.body;
          this.pageInfo.total = res1.totalCount || 0;
          this.polymerizationInfo = res2.body;
        });
      },
      /** 导出文件 */
      doExportFile() {
        commission.export('代理人佣金列表', this.searchParams);
      },
      onAddDrawerClose(done) {
        done();
      },
      /** 点击抽屉取消按钮 callback */
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            done();
            drawerDone();
            if (this.isEdit) {
              this.isEdit = false;
            }
          },
        });
      },
      /**
       * @desc 点击页面左上角按钮 callback
       * */
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(form) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParams, form);
        // if (form.createTime.length > 0) {
        //   [this.searchParams.createBeginTime, this.searchParams.createEndTime] = form.createTime;
        // }
        this.searchTableList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .drawer-button-wrap {
    padding: 0 10px;
    button {
      margin-right: 5px;
    }
  }
  .link {
    color: blue;
    cursor: pointer;
  }
  .el-radio-group .item {
    border: 0;
  }
</style>
